const {Component} = require("react");
const PropTypes = require("prop-types");

class BlockList extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			subtitle: PropTypes.string,
			items: PropTypes.array
		};
	}

	static get defaultProps() {
		return {
			title: "Block list",
			subtitle: "List",
			items: []
		};
	}

	get baseClassName() {
		return "static-list";
	}

	get className() {
		let classList = [this.baseClassName];

		if (this.props.items.length === 0) {
			classList.push("empty");
		}

		return classList.join(" ");
	}

	renderList() {
		// ... extend this
	}

	render() {
		return (
			<div className={this.className}>
				<div className="subtitle">{this.props.subtitle}</div>
				<p>{this.props.title}</p>
				{this.renderList()}
			</div>
		);
	}

}

module.exports = BlockList;